import React, { useState, useEffect } from 'react';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const MemberForm = ({
  formData,
  setFormData,
  onSubmit,
  registerTypes,
  countries,
  regions,
  districts,
  isEdit,
  viewMode,
  children
}) => {
  const [filteredRegions, setFilteredRegions] = useState([]);
  const [filteredDistricts, setFilteredDistricts] = useState([]);

  useEffect(() => {
    // Filter regions based on selected country
    if (formData.country) {
      const countryRegions = regions.filter(region => 
        region.country === formData.country || region.country?._id === formData.country
      );
      setFilteredRegions(countryRegions);
    } else {
      setFilteredRegions([]);
    }

    // Filter districts based on selected region
    if (formData.region) {
      const regionDistricts = districts.filter(district => 
        district.region === formData.region || district.region?._id === formData.region
      );
      setFilteredDistricts(regionDistricts);
    } else {
      setFilteredDistricts([]);
    }
  }, [formData.country, formData.region, regions, districts]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'country') {
      // When country changes, reset region and district
      setFormData(prev => ({ 
        ...prev, 
        country: value,
        region: '',
        district: ''
      }));
    } else if (name === 'region') {
      // When region changes, reset district
      setFormData(prev => ({ 
        ...prev, 
        region: value,
        district: ''
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, [field]: file }));
    }
  };

  return (
    <form onSubmit={onSubmit} className="members-form">
      <div className="form-sections">
        {/* Personal Information Section */}
        <div className="form-section">
          <h3 className="section-title">Personal Information</h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Register Type *</label>
              <select 
                name="registertype" 
                value={formData.registertype} 
                onChange={handleInputChange} 
                required
                disabled={viewMode}
              >
                <option value="">Select Register Type</option>
                {registerTypes.map(rt => (
                  <option key={rt._id} value={rt._id}>{rt.name}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>First Name *</label>
              <input 
                type="text" 
                name="fname" 
                value={formData.fname} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter first name"
              />
            </div>

            <div className="form-group">
              <label>Middle Name</label>
              <input 
                type="text" 
                name="mname" 
                value={formData.mname} 
                onChange={handleInputChange} 
                disabled={viewMode}
                placeholder="Enter middle name"
              />
            </div>

            <div className="form-group">
              <label>Last Name *</label>
              <input 
                type="text" 
                name="lname" 
                value={formData.lname} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter last name"
              />
            </div>

            <div className="form-group">
              <label>Mother's Name *</label>
              <input 
                type="text" 
                name="moname" 
                value={formData.moname} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter mother's name"
              />
            </div>

   <div className="form-group">
              <label>Email  *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                disabled={viewMode}   // ✅ only disabled in view mode
                placeholder="Enter email address"
              />
            </div>

            {!viewMode && !isEdit && (
              <>
                <div className="form-group">
                  <label>Password *</label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                    placeholder="Create password"
                  />
                </div>

                <div className="form-group">
                  <label>Confirm Password *</label>
                  <input
                    type="password"
                    name="cpassword"
                    value={formData.cpassword}
                    onChange={handleInputChange}
                    required
                    placeholder="Confirm password"
                  />
                </div>
              </>
            )}

            {!viewMode && isEdit && (
              <>
                <div className="form-group">
                  <label>Password (leave blank to keep current)</label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="New password"
                  />
                </div>

                <div className="form-group">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    name="cpassword"
                    value={formData.cpassword}
                    onChange={handleInputChange}
                    placeholder="Confirm new password"
                  />
                </div>
              </>
            )}

            <div className="form-group">
              <label>Mobile *</label>
              <input 
                type="tel" 
                name="mobile" 
                value={formData.mobile} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter mobile number"
              />
            </div>

            <div className="form-group">
              <label>Date of Birth *</label>
              <input 
                type="date" 
                name="dob" 
                value={formData.dob} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
              />
            </div>

            <div className="form-group">
              <label>Place of Birth *</label>
              <input 
                type="text" 
                name="pob" 
                value={formData.pob} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter place of birth"
              />
            </div>

            <div className="form-group">
              <label>Sex *</label>
              <select 
                name="sex" 
                value={formData.sex} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
              >
                <option value="">Select Sex</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>

            <div className="form-group">
              <label>Education Level *</label>
              <input 
                type="text" 
                name="elevel" 
                value={formData.elevel} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter education level"
              />
            </div>

            <div className="form-group">
              <label>Residence *</label>
              <input 
                type="text" 
                name="residence" 
                value={formData.residence} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter residence address"
              />
            </div>
          </div>
        </div>

        {/* Location Information Section */}
        <div className="form-section">
          <h3 className="section-title">Location Information</h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Country *</label>
              <select 
                name="country" 
                value={formData.country} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
              >
                <option value="">Select Country</option>
                {countries.map(country => (
                  <option key={country._id} value={country._id}>{country.name}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Region *</label>
              <select 
                name="region" 
                value={formData.region} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode || !formData.country}
              >
                <option value="">Select Region</option>
                {filteredRegions.map(region => (
                  <option key={region._id} value={region._id}>{region.name}</option>
                ))}
              </select>
              {!formData.country && <span className="field-note">Please select a country first</span>}
            </div>

            <div className="form-group">
              <label>District *</label>
              <select 
                name="district" 
                value={formData.district} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode || !formData.region}
              >
                <option value="">Select District</option>
                {filteredDistricts.map(district => (
                  <option key={district._id} value={district._id}>{district.name}</option>
                ))}
              </select>
              {!formData.region && <span className="field-note">Please select a region first</span>}
            </div>
          </div>
        </div>

        {/* Bank Information Section */}
        <div className="form-section">
          <h3 className="section-title">Bank Information</h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Payment Terms *</label>
              <input 
                type="text" 
                name="PaymentTerms" 
                value={formData.PaymentTerms} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter payment terms"
              />
            </div>

            <div className="form-group">
              <label>Bank Name</label>
              <input 
                type="text" 
                name="bankname" 
                value={formData.bankname} 
                onChange={handleInputChange} 
                disabled={viewMode}
                placeholder="Enter bank name (optional)"
              />
            </div>

            <div className="form-group">
              <label>Bank Address *</label>
              <input 
                type="text" 
                name="bankaddress" 
                value={formData.bankaddress} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter bank address"
              />
            </div>

            <div className="form-group">
              <label>Account Number</label>
              <input 
                type="text" 
                name="accno" 
                value={formData.accno} 
                onChange={handleInputChange} 
                disabled={viewMode}
                placeholder="Enter account number (optional)"
              />
            </div>
          </div>
        </div>

        {/* Next of Kin Section */}
        <div className="form-section">
          <h3 className="section-title">Next of Kin Information</h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Next of Kin 1 Name *</label>
              <input 
                type="text" 
                name="nokname1" 
                value={formData.nokname1} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter name"
              />
            </div>

            <div className="form-group">
              <label>Next of Kin 1 Address *</label>
              <input 
                type="text" 
                name="nokaddress1" 
                value={formData.nokaddress1} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter address"
              />
            </div>

            <div className="form-group">
              <label>Next of Kin 1 Mobile *</label>
              <input 
                type="text" 
                name="nokmobile1" 
                value={formData.nokmobile1} 
                onChange={handleInputChange} 
                required 
                disabled={viewMode}
                placeholder="Enter mobile number"
              />
            </div>

            <div className="form-group">
              <label>Next of Kin 2 Name</label>
              <input 
                type="text" 
                name="nokname2" 
                value={formData.nokname2} 
                onChange={handleInputChange} 
                disabled={viewMode}
                placeholder="Enter name (optional)"
              />
            </div>

            <div className="form-group">
              <label>Next of Kin 2 Address</label>
              <input 
                type="text" 
                name="nokaddress2" 
                value={formData.nokaddress2} 
                onChange={handleInputChange} 
                disabled={viewMode}
                placeholder="Enter address (optional)"
              />
            </div>

            <div className="form-group">
              <label>Next of Kin 2 Mobile</label>
              <input 
                type="text" 
                name="nokmobile2" 
                value={formData.nokmobile2} 
                onChange={handleInputChange} 
                disabled={viewMode}
                placeholder="Enter mobile number (optional)"
              />
            </div>
          </div>
        </div>

        {/* Documents Section */}
        {!viewMode && (
          <div className="form-section">
            <h3 className="section-title">Documents</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Photo {!isEdit && '*'}</label>
                <input
                  type="file"
                  name="photo"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'photo')}
                  required={!isEdit}
                  disabled={viewMode}
                />
                {formData.photo && (
                  <div className="file-preview">
                    <img 
                      src={formData.photo instanceof File ? URL.createObjectURL(formData.photo) : `${url}/${formData.photo}`} 
                      alt="Photo Preview" 
                      className="preview-image"
                    />
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Identity Document {!isEdit && '*'}</label>
                <input
                  type="file"
                  name="identity"
                  accept="image/*,.pdf,.doc,.docx"
                  onChange={(e) => handleFileChange(e, 'identity')}
                  required={!isEdit}
                  disabled={viewMode}
                />
                {formData.identity && (
                  <div className="file-preview">
                    {formData.identity instanceof File ? (
                      formData.identity.type.startsWith('image/') ? (
                        <img 
                          src={URL.createObjectURL(formData.identity)} 
                          alt="Identity Preview" 
                          className="preview-image"
                        />
                      ) : (
                        <span className="file-name">{formData.identity.name}</span>
                      )
                    ) : (
                      formData.identity.endsWith('.pdf') ? (
                        <a href={`${url}/${formData.identity}`} target="_blank" rel="noopener noreferrer" className="file-link">
                          View Current Document
                        </a>
                      ) : (
                        <img 
                          src={`${url}/${formData.identity}`} 
                          alt="Identity Preview" 
                          className="preview-image"
                        />
                      )
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {children}
    </form>
  );
};

export default MemberForm;
